export default __webpack_public_path__ + "static/media/Tenebrous Girdle.5d6a347c.jpg";